import { APIClient, JavaAPIClient } from '../lib/apiHelper';

const { get, post, put, remove } = new APIClient();
const { get: getJava, post: postJava, put: putJava, remove: removeJava } = new JavaAPIClient();

export default {
	list: (type, comapnyId, query=null, category=null) => getJava(`/board/${comapnyId}/${type}${category ? `?category=${category}&${query ? new URLSearchParams(query).toString() : ''}` : `?${query ? new URLSearchParams(query).toString() : ''}`}`),
	pubList: (type, comapnyId) => getJava(`/board/pub?companyId=${comapnyId}&type=${type}`),
    view: (type, comapnyId, idx) => getJava(`/board/${comapnyId}/${type}/${idx}`),
	add: (type, comapnyId, data) => postJava(`/board/${comapnyId}/${type}`, data),
	update: (type, comapnyId, idx, data) => putJava(`/board/${comapnyId}/${type}/${idx}`, data),
	delete: (type, comapnyId, idx) => removeJava(`/board/${comapnyId}/${type}/${idx}`),
	readCount: (type, comapnyId) => getJava(`/board/${comapnyId}/${type}/readCnt`),

    deleteImage: (idx, index) => removeJava(`/board/image/${idx}/${index}`),
	uploadImage: (data) => postJava(`/board/file/upload`, data),
    download: (idx, index) => getJava(`/board/file/${idx}/${index}`,{},'blob'),
    // REPLY
    replyList: (type, comapnyId, idx) => getJava(`/reply/${comapnyId}/${type}/${idx}`),
    replyView: (type, comapnyId, idx, ridx) => getJava(`/reply/${comapnyId}/${type}/${idx}/${ridx}`),
	replyAdd: (type, comapnyId, idx, data) => postJava(`/reply/${comapnyId}/${type}/${idx}`, data),
	replyUpdate: (type, comapnyId, ridx, data) => putJava(`/reply/${comapnyId}/${type}/${ridx}`, data),
	replyDelete: (type, comapnyId, ridx) => removeJava(`/reply/${comapnyId}/${type}/${ridx}`),
};
